export { default as ComponentStyle } from '@/styles/components/delete-candidate-modal/_index.module.scss';
export { default as Button } from '@/components/button';
export {default as Image} from 'next/image';
export { closeModalUsingState} from '@/actions/common/close-modal';